export const enum HistoryDumpFormat {
    Txt,
    Html,
}
